import Close from "./Close";

export * from "./Triangle";
export * from "./Check";
export * from "./Close";

export const Shapess = {
  Close,
};
